import { PayloadAction } from "@reduxjs/toolkit";
import { call, put, takeLatest } from "redux-saga/effects";
import { facilitiesApi } from "../../services/facilities.api";
import { HealthcareFacilityStats } from "../../types/facility.definition";
import {
  fetchStatsFailure,
  fetchStatsRequest,
  fetchStatsSuccess,
} from "../reducers/dashboardSlice";

// Mock API call
function* fetchStatsSaga({
  payload,
}: PayloadAction<{ facilityId: number }>): Generator<
  unknown,
  void,
  HealthcareFacilityStats
> {
  try {
    const stats = yield call(
      facilitiesApi.fetchFacilityStats,
      payload.facilityId
    );
    yield put(fetchStatsSuccess(stats));
  } catch (error) {
    yield put(
      fetchStatsFailure(
        error instanceof Error ? error.message : "Failed to fetch stats"
      )
    );
  }
}

export function* watchDashboard() {
  yield takeLatest(fetchStatsRequest.type, fetchStatsSaga);
}
